/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loginintro1Inputs */

const en_loginintro1 = /** @type {(inputs: Loginintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We'll email you a one-click link to sign in. No password needed.`)
};

const pt_loginintro1 = /** @type {(inputs: Loginintro1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviamos-lhe por email um link de acesso de um clique. Sem palavra-passe.`)
};

/**
* | output |
* | --- |
* | "We'll email you a one-click link to sign in. No password needed." |
*
* @param {Loginintro1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const loginintro1 = /** @type {((inputs?: Loginintro1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loginintro1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_loginintro1(inputs)
	return pt_loginintro1(inputs)
});
export { loginintro1 as "loginIntro" }